import { render } from "./ResourceCards.vue?vue&type=template&id=50d279ea"
import script from "./ResourceCards.vue?vue&type=script&lang=js"
export * from "./ResourceCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__